<template>
    <slideout-content v-on="$listeners">
        <template #header>
            <ul class="nav nav-tabs tab-panel" style="margin-top: -25px;">
                <li class="nav-item">
                    <button class="nav-link gap-2" id="tabAttachmentsButton" :class="{active: activeTab === TAB_ATTACHMENTS}"
                            data-bs-toggle="tab" data-bs-target="#tabAttachments" role="tab"
                            aria-controls="tabAttachments" aria-selected="true">
                        <i class="fi fi-rr-clip"></i>
                        <span>{{ trans('general.page.space_billing.payment.attachments') }}</span>

                    </button>
                </li>
            </ul>
        </template>
        <template #content>
            <div class="tab-content" id="tabAttachments">
                <div class="tab-pane fade" :class="{'show active': true}" :id="TAB_ATTACHMENTS"
                     role="tabpanel" aria-labelledby="tabAttachmentsButton">
                    <payment-documents-list v-on:documents-total="totalDocuments = $event" :payment-id="paymentId" />
                </div>
            </div>
        </template>
    </slideout-content>
</template>

<script>
import PaymentDocumentsList from "./PaymentDocumentsList.vue";
import SlideoutContent from "../../../theme/molecules/SlideoutContent.vue";

const TAB_ATTACHMENTS = 'tabAttachments'
export default {
    name: "PaymentDocumentationPanel",
    props: {
        paymentId: Number | String,
        activeTab: {
            type: String,
            required: false
        }
    },
    components: {
        SlideoutContent,
        PaymentDocumentsList
    },
    data() {
        return {
            TAB_ATTACHMENTS: TAB_ATTACHMENTS,
            totalDocuments: null
        }
    },
    methods: {
        closePanel(event) {
            event.preventDefault()
            this.$emit('closePanel', {totalDocuments: this.totalDocuments});
        },
    }
}
</script>

<style scoped>
.tab-panel .nav-item .nav-link {
    font-size: 1rem;
}
</style>
